import {
  styled,
  styledDiv,
  emotionStyled,
  tokens,
} from '@packages/utilities/styled';
import {Grid} from '@packages/systems/design-system/Grid';

export const dropdownHoverNoteGroupStyle = {
  borderTop: '1px dotted black',
} as const;
export const dropdownOptionNoteStyle = {
  boxShadow: 'rgb(51, 51, 51) 0px -1px 0px',
} as const;

export const Label = styled('span')(
  ({theme: {gutters}, hasMargin, isOverride}) => ({
    alignItems: 'center',
    display: 'flex',
    marginLeft: hasMargin ? gutters.x4 : 0,
    color: isOverride ? tokens.colors.textSecondary : 'inherit',
  })
);

export const Block = styledDiv(({theme: {gutters}, size}) => ({
  minWidth: Math.max(0, (size - 1) * (gutters.x4 * 3)),
}));

export const IconWrapper = styledDiv(
  ({theme: {gutters, colors}, top = 1}) => ({
    alignItems: 'center',
    color: colors.foreground,
    display: 'flex',
    position: 'relative',
    top,
    width: gutters.x4 * 3,
  }),
  {
    marginRight: ({theme: {gutters}}) => ({marginRight: gutters.x4}),
  }
);

export const FlexWrapper = emotionStyled('div')({
  alignItems: 'baseline',
  display: 'inline-flex',
  maxWidth: '100%',
});

export const OneLine = styled(Grid)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const ImagePreview = emotionStyled('img')({
  gridColumn: '1 / 2',
  gridRow: '1 / -1',
  background: tokens.colors.background4,
  width: '100%',
  height: '100%',
  borderRadius: tokens.controls.borderRadius,
  borderWidth: tokens.controls.borderWidth,
  borderStyle: 'solid',
  borderColor: tokens.colors.border3,
  objectFit: 'contain',
});
